/*
 * @Descripttion: 废弃
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-03-09 15:40:41
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-09 10:04:24
 */
import React from 'react'
import Logo from './images/logo1.png'
import { Menu, Dropdown, Button, Avatar } from 'antd'
import { Link, Redirect } from 'react-router-dom'
import './index.css'
import './index_mobile.css'
import tx from '../../statics/suzhou.jpg'
import { connect } from 'react-redux'
import { login, logout } from '../../service/loginaction'
class Header2 extends React.Component {
    componentDidMount() {

    }
    render() {
        const menu1 = (<Menu className="newheader-navigation-menu">
            <Menu.Item>
                <Link to='/NewsBulletin' >
                    新闻资讯
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/Repository' >
                    知识库
                </Link>
            </Menu.Item>
        </Menu>
        )
        const menuTrain = (<Menu className="newheader-navigation-menu">
            <Menu.Item>
                <Link to='/OnlineTraining' >
                    教学中心
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/OnlineClass' >
                    在线课堂
                </Link>
            </Menu.Item>
        </Menu>
        )
        const menu2 = (<Menu className="newheader-navigation-menu">
            <Menu.Item>
                <Link to='/Upload'>
                    资源集成
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/Download' >
                    文档资源共享
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/geovis' >
                    数据资源服务
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/sensing' >
                    微波遥感特征库检索
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/CloudStorage' target="_blank">
                    云盘
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/processdesign' target='_blank'>
                    流程定制
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/DownloadTools'>
                    算法模型
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/onlineApi'>
                    API在线开发
                </Link>
            </Menu.Item>
        </Menu>
        )
        const usermenu = <Menu className="newheader-navigation-menu">
            <Menu.Item>
                <Link to='/usercenter/myaccount'>
                    个人中心
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/userresource'>
                    个人订单
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/CloudStorage'>
                    个人云盘(我的上传)
                </Link>
            </Menu.Item>
            {/* <Menu.Item>
                <Link to='/ManagerCenter'>
                    管理中心
                </Link>
            </Menu.Item> */}
            <Menu.Item className='header-menuitem' onClick={this.props.logout}>
                {"退出登录"}
            </Menu.Item>
        </Menu>
        const messagemenu = <Menu className="newheader-navigation-menu">
            <Menu.Item>
                <Link to='/usercenter'>
                    回复我的
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/userresource'>
                    系统通知
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to='/CloudStorage'>
                    我的消息
                </Link>
            </Menu.Item>
        </Menu>
        if (this.props.loginObj && this.props.loginObj.login) {
            return (
                // <div>            
                <div className="hidden-scroll" >
                    <div className={`header-panel headertype-2`}
                    // style={{ height: 64,backgroundColor:this.state.headertype===1?'tranparent':'red' }}
                    >
                        <div className="header-white-panel"  ></div>
                        <div className="header-logo-panel"  >
                            <Link to='/Guide'>
                                <img className="header-logo" src={Logo}></img>
                            </Link>
                            <div className={'header-title-text'} >
                                <div className={'header-title-text-cn'} style={{ color: 'white' }}>
                                    国家民用空间基础设施共性技术支撑服务网
                                </div>
                                <div className={'header-title-text-en'} style={{ color: 'white' }}>
                                    National Space Infrastructure Common Application Technology Support Service Website
                                </div>

                            </div>
                        </div>
                        <div className='header-menu-panel'>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Dropdown
                                    overlay={menu1}
                                    placement="bottomLeft"
                                >
                                    <div className="newheader-navigation">走进空基</div>
                                </Dropdown>
                                <Dropdown
                                    overlay={menu2}
                                    placement="bottomLeft"
                                >
                                    <div className="newheader-navigation">资源服务</div>
                                </Dropdown>
                                {/* <Link>
                                <div className="newheader-navigation">在线分析</div>
                            </Link> */}
                                <Dropdown
                                    overlay={menuTrain}
                                    placement="bottomLeft"
                                >
                                    <div className="newheader-navigation">在线培训</div>
                                </Dropdown>

                                <Link
                                    to={{
                                        pathname: '/Q&ACenter',
                                        type: 'center'
                                    }}
                                >  <div className="newheader-navigation">问答中心</div> </Link>
                                <Link
                                    to={{
                                        pathname: '/Q&ACenter',
                                        type: 'center'
                                    }}
                                >  <div className="newheader-navigation">帮助</div> </Link>
                                <Link
                                    to={{
                                        pathname: '/Q&ACenter',
                                        type: 'center'
                                    }}
                                >  <div className="newheader-navigation">客服</div> </Link>
                                {/* <Link to='/ManagerCenter'>
                                <div className="newheader-navigation">管理中心</div>
                            </Link> */}
                            </div>
                        </div>
                        <div className='header-user-panel' >
                            {/* {this.props.loginObj && this.props.loginObj.login ? */}
                            <div >
                                <Dropdown
                                    overlay={usermenu}
                                // placement="Bottom"
                                // trigger='click'
                                >
                                    <div className="newheader-username">
                                        <Avatar className='header-username-avatar' style={{ marginRight: 20 }} src={tx}></Avatar>
                                        {this.props.user.userName}
                                    </div>
                                </Dropdown>
                                <Dropdown
                                    overlay={messagemenu}
                                // placement="Bottom"
                                // trigger='click'
                                >
                                    <div className="newheader-username" style={{ marginLeft: 20 }} >
                                        消息(2)
                                    </div>
                                </Dropdown>
                            </div>
                            {/* : <Link to='/UserLogin'> <Button className="userlogoin">登录</Button></Link>} */}
                        </div>

                    </div>

                    {/* <div style={{ height: 64, width: '100%' }}></div> */}
                </div>

                // </div> 
            )
        } else {
            return <Redirect path='/Login' to='/Home' />
        }
    }
}

/**
 * 
 * @param {*} state 代表外部传来的数据
 */
const mapState = (state) => ({ //返回值  对应的是  组件的props
    // loginStatus: state.loginreducer.loginstate,
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
    // userName: state.loginreducer.userName
})
/**
 * 用来建立 UI 组件的参数到store.dispatch方法的映射。它定义了哪些用户的操作应该当作 Action，传给 Store。它可以是一个函数，也可以是一个对象。
 * @param {*} dispatch 
 * @param {*} ownProps 容器组件的props对象
 */
const mapDispatch = (dispatch, ownProps) => ({
    //组件中的方法名称 组件通过this.props.fucname(para1,para2)来调用方法
    // { type: 'increase' }定义了外部对这个方法的描述信息，
    // login: (userName, password) => dispatch({ type: 'login', userName: userName }),
    // logout: () => dispatch({ type: 'logout' })
    login: (param) => dispatch(login(param)),
    logout: () => dispatch(logout())
})
/**
 * connect方法接受两个参数： * mapStateToProps 和 mapDispatchToProps。它们定义了 UI 组件的业务逻辑。
 * mapStateToProps 负责输入逻辑，即将state映射到 UI 组件的参数（props），
 * mapDispatchToProps 负责输出逻辑，即将用户对 UI 组件的操作映射成 Action。
 */
export default connect(mapState, mapDispatch)(Header2);